import { render } from "./SingleVrComponent.vue?vue&type=template&id=48d91648"
import script from "./SingleVrComponent.vue?vue&type=script&lang=js"
export * from "./SingleVrComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/twilkinson/Documents/DevProjects/AF3/af3-shortcodes-plugin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__